import { render } from "./AssignementsSubmitted.vue?vue&type=template&id=0a85bc99&scoped=true"
import script from "./AssignementsSubmitted.vue?vue&type=script&lang=js"
export * from "./AssignementsSubmitted.vue?vue&type=script&lang=js"

import "./AssignementsSubmitted.vue?vue&type=style&index=0&id=0a85bc99&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85bc99"]])

export default __exports__